import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgItalic = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "1em",
	viewBox: "-4 -4 32 32",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "m7 19.47 7 .06m-3-15.06 7 .06" }), /* @__PURE__ */ _jsx("path", {
			d: "m14.5 5-4 14",
			strokeLinecap: "square"
		})]
	})
});
export default SvgItalic;
